import { LeadPhoneViewStoreFactory } from 'mobile/module/lead/phone/view-store.factory';

const service = LeadPhoneViewStoreFactory();

export const LeadPhoneService = () => service;
